<div
  class="dialog-header flex align-items-center justify-content-between w-full"
>
  <h1 class="text-xl">Detalii pentru cutia {{ boxData()?.uniqueId }}</h1>

  <div class="flex justify-content-between align-items-center gap-2">
    <!-- <p-button
      size="small"
      pTooltip="Reîncarca datele"
      tooltipPosition="top"
      icon="pi pi-sync"
      [loading]="fetching() === 'LOADING'"
      loadingIcon="pi pi-sync"
      styleClass="p-button-icon"
      (click)="fetchData()"
    /> -->
    <p-button
      mat-dialog-close
      size="small"
      icon="pi pi-times"
      severity="secondary"
      [autofocus]="false"
      [rounded]="true"
      [text]="true"
    />
  </div>
</div>

<mat-dialog-content>
  @switch (fetching()) { @case ("ERROR") {
  <div class="flex justify-content-center align-items-center">
    <h2 class="text-base">A aparut o eroare</h2>
  </div>
  } @case ("LOADING") {
  <div class="flex justify-content-center align-items-center p-4">
    <p-progressSpinner
      styleClass="w-4rem h-4rem"
      strokeWidth="4"
      fill="var(--surface-ground)"
      animationDuration=".5s"
    />
  </div>
  } @case ("SUCCESS") {
  <div class="box-actions p-3">
    <h2 class="text-lg mb-3">Acțiuni disponibile</h2>

    <div class="action-buttons grid">
      <!-- Force Open Button -->
      <div class="col-12 md:col-6 mb-2">
        <p-button
          label="Forțează deschiderea"
          icon="pi pi-unlock"
          severity="warning"
          [disabled]="performingAction()"
          styleClass="w-full"
          (click)="confirmAction('open')"
        ></p-button>
      </div>

      <!-- Clear Errors Button -->
      <div class="col-12 md:col-6 mb-2">
        <p-button
          label="Șterge erorile"
          icon="pi pi-trash"
          severity="help"
          [disabled]="performingAction() || !boxData()?.isErrored"
          styleClass="w-full h-full"
          (click)="confirmAction('clearErrors')"
        ></p-button>
      </div>

      <!-- Mark as Fixed/Broken Button -->
      <div class="col-12 mb-2">
        @if (boxData()?.isDisabled) {
        <p-button
          label="Marchează ca funcțională (Disabled)"
          icon="pi pi-check-circle"
          severity="success"
          [disabled]="performingAction()"
          styleClass="w-full"
          (click)="confirmAction('enable')"
        ></p-button>
        } @else {
        <p-button
          label="Marchează ca scoasă din uz (Disabled)"
          icon="pi pi-exclamation-triangle"
          severity="danger"
          [disabled]="performingAction()"
          styleClass="w-full"
          (click)="confirmAction('disable')"
        ></p-button>
        }
      </div>

      <div class="col-12 mb-2">
        @if (boxData()?.isBroken) {
          <p-button
            label="Marchează ca reparata (Broken)"
            icon="pi pi-check-circle"
            severity="success"
            [disabled]="performingAction()"
            styleClass="w-full"
            (click)="confirmAction('unbroken')"
          ></p-button>
        } @else {
          <p-button
            label="Marchează ca stricată (Broken)"
            icon="pi pi-exclamation-triangle"
            severity="danger"
            [disabled]="performingAction()"
            styleClass="w-full"
            (click)="confirmAction('broken')"
          ></p-button>
        }
      </div>
    </div>
  </div>

  <div class="box-details p-3">
    <h2 class="text-lg mb-3">Informații despre cutie</h2>

    <div class="status-grid grid">
      <div class="col-6 md:col-4">
        <div class="status-item mb-2">
          <span class="font-medium">Id unic cutie:</span>
          <div class="status-value">
            <p>{{ boxData()?.uniqueId }}</p>
          </div>
        </div>
      </div>
      <div class="col-6 md:col-4">
        <div class="status-item mb-2">
          <span class="font-medium">AWB:</span>
          <div class="status-value">
            <p>{{ boxData()?.awb ?? "" }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="status-grid grid">
      <div class="col-6 md:col-4">
        <div class="status-item mb-2">
          <span class="font-medium">Status:</span>
          <div class="status-value">
            <p-tag
              [severity]="getBoxStatusSeverity()"
              [value]="getBoxStatusLabel()"
            ></p-tag>
          </div>
        </div>
      </div>

      <div class="col-6 md:col-4">
        <div class="status-item mb-2">
          <span class="font-medium">Disponibilă:</span>
          <div class="status-value">
            <p-tag
              [severity]="boxData()?.isDisabled ? 'danger' : 'success'"
              [value]="boxData()?.isDisabled ? 'Nu' : 'Da'"
            ></p-tag>
          </div>
        </div>
      </div>

      <div class="col-6 md:col-4">
        <div class="status-item mb-2">
          <span class="font-medium">Ocupată:</span>
          <div class="status-value">
            <p-tag
              [severity]="boxData()?.isFull ? 'info' : 'success'"
              [value]="boxData()?.isFull ? 'Da' : 'Nu'"
            ></p-tag>
          </div>
        </div>
      </div>
    </div>
  </div>
  } }
</mat-dialog-content>

<!-- Standard Confirmation Dialog (for other uses if needed) -->
<p-confirmDialog
  header="Confirmare"
  icon="pi pi-exclamation-triangle"
  [style]="{ width: '450px' }"
  acceptLabel="Da"
  rejectLabel="Nu"
></p-confirmDialog>

<!-- Custom Dialog with Conditional Textarea -->
<p-dialog
  [visible]="showConfirmDialog()"
  (visibleChange)="showConfirmDialog.set($event)"
  [header]="confirmDialogHeader()"
  [modal]="true"
  [style]="{ width: '450px' }"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  (onHide)="cancelAction()"
  [closable]="true"
>
  <div class="dialog-content">
    <div class="flex align-items-center mb-3">
      <i
        class="pi pi-exclamation-triangle mr-2"
        style="font-size: 1.5rem; color: var(--yellow-500)"
      ></i>
      <p>{{ confirmDialogMessage() }}</p>
    </div>

    <!-- Conditionally show the textarea only for 'open' action -->
    @if (shouldShowReason()) {
    <div class="field mt-4">
      <label for="reason" class="block font-medium mb-2">
        Motivul acțiunii: <span class="text-sm text-gray-500">(opțional)</span>
      </label>
      <textarea
        id="reason"
        pInputTextarea
        [ngModel]="actionReason()"
        (ngModelChange)="updateReason($event)"
        rows="3"
        class="w-full"
        placeholder="Introduceți motivul pentru această acțiune (opțional)..."
      ></textarea>
    </div>
    }
  </div>

  <p>
    Pentru a continua, va rugam sa tastati <b>"{{ SECURITY_KEYWORD() }}"</b> in campul
    de mai jos
  </p>
  <input pInputText [(ngModel)]="securityKeywordControl" class="w-full" />

  <ng-template pTemplate="footer">
    <p-button
      label="Nu"
      icon="pi pi-times"
      styleClass="p-button-text"
      (click)="cancelAction()"
    ></p-button>
    <p-button
      label="Da"
      icon="pi pi-check"
      [disabled]="!canProceed()"
      (click)="confirmActionWithReason()"
    ></p-button>
    <!-- [disabled]="actionReason() === '' ||
                  actionReason() === undefined ||
                  actionReason().length < 7" -->
  </ng-template>
</p-dialog>
